<p-buttonGroup class="p-buttongroup p-component" *ngIf="config?.typeOptions?.config?.type === 'ADVANCED'">
  <button
    pButton
    [icon]="item.icon"
    type="button"
    class="p-button-outlined p-button-sm p-button p-component"
    [label]="item.name | translate"
    [disabled]="checkedItems?.length === 0"
    (click)="handleToggle()"></button>
  <button
    pButton
    type="button"
    class="p-button-outlined p-button-sm p-button p-component p-button-icon-only ng-star-inserted w-8 max-w-8"
    icon="fa-regular fa-plus"
    [disabled]="checkedItems?.length === 0"
    (click)="handleShowDialog()"></button>
</p-buttonGroup>

<div *ngIf="config?.typeOptions?.config?.type !== 'ADVANCED'">
  <button
    pButton
    [icon]="item.icon"
    type="button"
    class="p-button-outlined p-button p-button-sm justify-content-left flex-grow-1 no-underline"
    [label]="item.name | translate"
    [disabled]="checkedItems?.length === 0"
    (click)="handleToggle()"></button>
</div>

<app-detail-action-button-toggle-dialog
  [(visible)]="dialogVisible"
  [title]="item.name | translate"
  [url]="config?.typeOptions?.url"
  [meetingItemIds]="filteredMeetingItemIds"
  (endAction)="endAction.emit()"></app-detail-action-button-toggle-dialog>
